<template>
    <Overlay :show="showLoading">
        <SaveAndProceedOrRefusePrompt
            ref="saveAndProceedPrompt"
            @rejectAndProceed="rejectAndGotoSendRequest"
            @saveAndProceed="saveAndGotoSendRequest"
        />
        <b-row>
            <b-col md="8" class="mb-2">
                <h2 class="float-left pr-1 mb-1">
                    {{ $t('Page(NewProduct):Component(text):type_' + type) }}
                </h2>
            </b-col>
            <b-col>
                <div class="float-right">
                    <b-button
                        variant="primary"
                        @click="save"
                        class="mr-1"
                    >
                        {{ $t('Component(Button):save') }}
                    </b-button>
                    <b-button
                        variant="primary"
                        @click="() => back(true)"
                    >
                        {{ $t('Component(Button):back') }}
                    </b-button>
                </div>

            </b-col>
        </b-row>
        <b-card>
            <b-row>
                <b-col>
                    <b-row>
                        <b-col sm="5" md="6">
                            <product-attribute
                                id="product-name"
                                :label="$t('Page(NewProduct):Component(Text):product-name')"
                                :placeholder="$t('Page(NewProduct):Component(Placeholder):product-name')"
                                :value-placeholder="$t('Page(NewProduct):Component(Placeholder):product-name-value')"
                                :options="attributes['ProductName'] || []"
                                :selected="names"
                                :hidden-elements-title="$t('Page(ProductCard):Component(ProductNames):hidden-names-collapse')"
                                :number-of-visible-items="10"
                                @change="onNameChange"
                                @add="addName"
                                @remove="removeName"
                            />
                        </b-col>
                        <b-col sm="5" md="6">
                            <product-attribute
                                id="product-identifier"
                                :radio-value="echaPrimaryKeyIndex"
                                :show-radio="isChemity"
                                :label="$t('Page(NewProduct):Component(Text):product-id')"
                                :placeholder="$t('Page(NewProduct):Component(Placeholder):product-id')"
                                :value-placeholder="$t('Page(NewProduct):Component(Placeholder):product-id-value')"
                                :options="attributes['ProductId'] || []"
                                :selected="identifiers"
                                :hidden-elements-title="$t('Page(ProductCard):Component(ProductIdentifiers):hidden-identifiers-collapse')"
                                :number-of-visible-items="10"
                                :show-radio-for-item="showRadioForIdentifier"
                                @change="onIdChange"
                                @add="addId"
                                @remove="removeId"
                                @radio="onPrimaryKeyChange"
                            />
                        </b-col>
                    </b-row>
                    <b-row v-if="showProductWeight">
                        <b-col>
                            <b-form-group
                                :label="$t('Component(Placeholder):product-weight')"
                                label-for="productWeight"
                            >
                                <b-form-input
                                    type="number"
                                    id="productWeight"
                                    :placeholder="$t('Component(Placeholder):product-weight')"
                                    v-model="weight"
                                />
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row v-if="showBusinessRoles">
                        <b-col md="12">
                            <BusinessRoles
                                :placeholder="$t('Page(NewProduct):Component(Placeholder):business-roles')"
                                @change="setBusinessRoles"
                            />
                        </b-col>
                    </b-row>
                    <b-row v-if="showIncludedIntoProductGroups">
                        <b-col md="12">
                            <IncludedProductGroups
                                :placeholder="$t('Page(ProductCard):Component(Placeholder):included-product-groups')"
                                :selected="parentProducts"
                                @change="onParentGroupsChange"
                            />
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col md="12">
                            <b-form-group
                                :label="$t('Component(Label):comment')"
                                label-for="product-comment"
                            >
                                <b-form-textarea
                                    id="product-comment"
                                    v-model="comment"
                                    rows="2"
                                    max-rows="8"
                                    maxlength="32000"
                                    :placeholder="$t('Component(Label):comment')"
                                />
                            </b-form-group>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>
        </b-card>
        <SupplierSelector
            v-if="type === types.PURCHASED"
            :add="canAddSupplier"
            @change="onSupplierChange"
        />
        <ProductCategorySelect
            :title="$t('Page(NewProduct):Component(Text):product-category')"
            @change="onProductCategoryChange"
        />
<!--        <IncludedProduct-->
<!--            :type="type"-->
<!--            @change="onIncludedProductChange"-->
<!--        />-->
    </Overlay>
</template>
<script>
import { BCardText, BCard, BRow, BCol, BFormGroup, BButton, BCardGroup, BOverlay, BFormInput, BFormTextarea } from 'bootstrap-vue'
import vSelect from 'vue-select'
import {BusinessRoles, CountrySelector, SupplierSelector} from "@core/components/supply-chain";
import {ProductApi} from '@core/api'
import {ProductIdentifiers, ProductNames, ProductType} from "@/libs/product";
import {IncludedProductGroups} from "@core/components/product";
import {ProductCategorySelect, ProductAttribute, IncludedProduct} from "@core/components/product";
import backendResponse from "@core/mixins/ui/backend-response";
import {SaveAndProceedOrRefusePrompt} from "@core/components/common";
import {ProductBreadcrumbs} from "@core/domain/product";
import Overlay from "@core/components/common/Overlay.vue";
import productIdentifier from "@/views/product/mixin/productIdentifier";
import {isChemity, isSustainity} from "@/libs/application";

export default {
    mixins: [backendResponse, productIdentifier],
    components: {
        Overlay, SaveAndProceedOrRefusePrompt, CountrySelector, BFormInput, BFormTextarea, BCard, BCardText, BButton, ProductAttribute,
        ProductCategorySelect, IncludedProduct, BRow, BCol, vSelect, BFormGroup, BCardGroup, BOverlay,
        IncludedProductGroups, BusinessRoles, SupplierSelector,
    },

    props: {
        type: {
            required: true
        },
        includeTo: {
            default: null
        },
        redirect: {
            default() {
                return ($router, productId) => {
                    $router.push({name: 'product-card', params: {id: productId}, props: {}});
                    // $router.push({name: 'product-overview'});
                };
            }
        }
    },

    data() {
        return {
            canAddSupplier: isChemity(),
            showLoading: false,
            step: 1,
            attributes: {},
            businessRoles: [],
            names: [],
            identifiers: [],
            types: ProductType,
            parentProducts: [],
            productCategories: [],
            includedProducts: [],
            suppliers: [],
            countryOfOrigin: null,
            echaPrimaryKeyIndex: null,
            echaPrimaryKeyType: null,
            weight: null,
            comment: '',

            isSustainity: isSustainity(),
            isChemity: isChemity(),

            initialState: ''
        };
    },

    methods: {
        saveAndGotoSendRequest(close) {
            close();
            this.save();
        },

        rejectAndGotoSendRequest() {
            this.back();
        },
        back(checkState = false) {
            if (checkState && this.initialState !== JSON.stringify(this.gatherProductData())) {
                this.$refs.saveAndProceedPrompt.show();
            } else {
                this.$router.go(-1);
            }
        },
        save() {
            this.showLoading = true;

            let message = 'Page(NewProduct):Component(ProductCreatedAck):text';
            let productId = null;

            return ProductApi
                .add(this.gatherProductData())
                .then((r) => {
                    productId = r.data.id;
                    if (this.includeTo) {
                    // if ((this.type === ProductType.PURCHASED || this.type === ProductType.OWN) && this.includeTo) {
                        message = 'Page(NewProduct):Component(ProductCreatedAck):text-component';
                        return ProductApi.includeComponents(this.includeTo, [{
                            id: parseInt(r.data.id),
                            numberOfUnits: 1
                        }]);
                    }
                })
                .then(() => {
                    this.showDefaultSuccessMessage(
                        this.$t(message),
                        true,
                        this.$t('Page(NewProduct):Component(ProductCreatedAck):title')
                    );
                    this.redirect(this.$router, productId);
                })
                .catch(this.handleBackendError)
                .finally(() => {
                    this.showLoading = false;
                });
        },
        gatherProductData() {
            const product = {
                type: this.type,
                parentGroups: this.parentProducts.map((p) => p.id),
                names: this.names.filter(v => v.key && v.value),
                identifiers: this.identifiers.filter(v => v.key && v.value),
                categories: this.productCategories,
                businessRoles: this.businessRoles,
                comment: this.comment || null,
                includedProducts: this.includedProducts,
                echaPKType: this.echaPrimaryKeyType,
            };

            if (this.countryOfOrigin) {
                product['countryOfOrigin'] = this.countryOfOrigin.id;
            }

            if (this.type !== ProductType.GROUP) {
                product['characteristics'] = {
                    weight: this.weight ? parseFloat(this.weight) : null
                };
            }

            if (this.type === ProductType.PURCHASED) {
                product.suppliers = this.suppliers;
            }

            return product;
        },
        onCountryOfOriginChange(country) {
            this.countryOfOrigin = country;
        },
        onParentGroupsChange(groups) {
            this.parentProducts = groups;
        },
        onSupplierChange(idList) {
            this.suppliers = idList;
        },
        onProductCategoryChange({idList, items}) {
            this.productCategories = idList;
        },
        onIncludedProductChange(products) {
            this.includedProducts = products.map(p => p.id);
        },
        setBusinessRoles(roles) {
            this.businessRoles = roles.map(v => v.id);
        },
        addName(object) {
            // if (object.isDefault === true) {
            //     const types = ;
            //     object.key = types.name;
            // }

            this.names.push({
                key: object.key,
                value: object.value,
            });
        },
        onNameChange(index, option) {
            this.names[index].key = option.key;
            this.names[index].value = option.value;
        },
        removeName(index) {
            this.names.splice(index, 1);
        },
        addId(object) {
            this.identifiers.push({
                key: object.key,
                value: object.value,
            });
        },
        removeId(index) {
            this.identifiers.splice(index, 1);
        },
        onIdChange(index, option) {
            this.identifiers[index].key = option.key;
            this.identifiers[index].value = option.value;
        },
        resolveDefaultProductNameTypeAndIdType() {
            switch (this.type) {
                case ProductType.GROUP:
                case ProductType.OWN:
                    return {
                        names: [ProductNames.OUR_PRODUCT_NAME],
                        identifiers: [ProductIdentifiers.PRODUCT_ID]
                    };

                case ProductType.COMPONENT_TO_COMPLEX_PURCHASED_PRODUCT:
                case ProductType.PURCHASED:
                    return {
                        names: [ProductNames.SUPPLIERS_PRODUCT_NAME, ProductNames.OUR_PRODUCT_NAME],
                        identifiers: [ProductIdentifiers.SUPPLIERS_PRODUCT_ID, ProductIdentifiers.PRODUCT_ID]
                    };

                default:
                    return {
                        names: [],
                        identifiers: [],
                    };
            }
        },
        onPrimaryKeyChange({index, attribute}) {
            this.echaPrimaryKeyIndex = index;
            this.echaPrimaryKeyType = attribute.key;
        },

        handleBreadcrumbs() {
            if (null === this.includeTo) {
                ProductBreadcrumbs.clear();
                ProductBreadcrumbs.push(
                    'Product overview',
                    this.$t('Component(Sidebar):products-overview'),
                    () => {
                        this.$router.push({name: 'product-overview'});
                    }
                );
            }
        }
    },

    computed: {
        isPurchasedProductComponent() {
            return this.type === ProductType.COMPONENT_TO_PURCHASED_PRODUCT
                || this.type === ProductType.COMPONENT_TO_COMPLEX_PURCHASED_PRODUCT;
        },
        showIncludedIntoProductGroups() {
            return !this.isPurchasedProductComponent;
        },
        showBusinessRoles() {
            return this.showIncludedIntoProductGroups;
        },
        showProductWeight() {
            return !(this.type === ProductType.FICTITIOUS || this.type === ProductType.GROUP);
        },
    },

    watch: {
        includeTo() {
            this.handleBreadcrumbs();
        }
    },

    created() {
        this.handleBreadcrumbs();
        this.showLoading = true;
        ProductApi
            .getAttributes()
            .then(r => {
                this.attributes = r.data;

                let defaults = this.resolveDefaultProductNameTypeAndIdType();

                if (defaults.names.length) {
                    defaults.names.forEach(type => this.addName({key: type, value: ''}));
                }

                if (defaults.identifiers) {
                    defaults.identifiers.forEach(type => this.addId({key: type, value: ''}));

                    let id = null;
                    for (let i = 0; i < this.identifiers.length; ++i) {
                        if (this.showRadioForIdentifier(this.identifiers[i])) {
                            id = this.identifiers[i];
                            break;
                        }
                    }

                    if (id){
                        this.echaPrimaryKeyType = id.key;
                    } else {
                        this.echaPrimaryKeyType = ProductIdentifiers.PRODUCT_ID;
                    }

                    this.echaPrimaryKeyIndex = 0;
                }
            })
            .finally(() => {
                this.initialState = JSON.stringify(this.gatherProductData());
                this.showLoading = false;
            })
        ;
    }
};
</script>
